/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GridPreferences = {
    /**
     * The name of the preference type
     */
    name: GridPreferences.name;
    /**
     * The values selected to be visible at the building level
     */
    building_rows: Array<string>;
    unit_rows: Array<string>;
};
export namespace GridPreferences {
    /**
     * The name of the preference type
     */
    export enum name {
        THE_GRID = 'the_grid',
    }
}

